import { faChevronRight, faHome } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Affix, Button } from "antd";
import { useEffect } from "react";
import { useState } from "react";
import { FormattedMessage } from "react-intl";
import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router";
import { RootState } from "../../../app/store";
import CloseButton from "../../../components/shared-components/CloseButton";
import { PlayerMode, selectPlayer } from "../../../features/player/playerSlice";
import {
  openSidebar,
  selectTheme,
  ThemeMode,
} from "../../../features/theme/themeSlice";
import { enableSidebar } from "../../../config/constants";

type TabsBarProps = {
  onClose?: () => void;
  openSidebarFn?: () => void;
  visible?: boolean;
  sidebarOpenButton?: boolean;
};

const TabsBar = ({
  onClose,
  openSidebarFn,
  visible = true,
  sidebarOpenButton = false,
}: TabsBarProps) => {
  const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
  const player = useAppSelector(selectPlayer);
  const theme = useAppSelector(selectTheme);
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();

  const l = document.getElementsByClassName("header");

  const [width, setWidth] = useState<number>(window.innerWidth);

  function handleWindowSizeChange() {
    setWidth(window.innerWidth);
  }
  useEffect(() => {}, []);

  const [isMobile, setIsMobile] = useState(false);

  const [affixSize, setAffixSize] = useState<number>(
    theme.mode === ThemeMode.KIOSK ? 50 : 94
  );
  const sidebar = enableSidebar.indexOf(location.pathname) > -1;
  useEffect(() => {
    window.addEventListener("resize", handleWindowSizeChange);
    return () => {
      window.removeEventListener("resize", handleWindowSizeChange);
    };
  }, []);

  useEffect(() => {
    if (!visible) setAffixSize(70);
  }, [visible]);

  useEffect(() => {
    setIsMobile(width < 900);
    if (visible) {
      if (width < 700)
        setAffixSize(50)
      else if (width > 700 && width < 900)
        setAffixSize(65)
      else
        setAffixSize(94)
    }
  }, [width, visible]);

  return !visible ? (
    !theme.sidebarStatus && sidebar && (
      <div style={{ position: "absolute" }}>
       
          <div
            className="pointer not-visible-tabs-bar-sidebar-button"
            onClick={(e) => {
              e.preventDefault();
              dispatch(openSidebar(true));
            }}
          >
            <FontAwesomeIcon icon={faChevronRight} />
          </div>
      
      </div>
    )
  ) : (
    
      <div
        className={`d-flex f-row d-tabsbar ${
          theme.sidebarStatus && !isMobile && sidebar ? "m-400" : ""
        }`}
      >
        {!theme.sidebarStatus && enableSidebar.indexOf(location.pathname) > -1 && (
          <div
            className="d-show-sidebar pointer"
            onClick={() => {
              dispatch(openSidebar(true));
            }}
          >
            <FontAwesomeIcon icon={faChevronRight} />
          </div>
        )}
        {/* <Button
					className={`${location.pathname === '/virtua' || location.pathname === '/' ? 'active' : ''}`}
					onClick={() => {
						navigate('/');
					}}
				>
					Home
				</Button> */}
        <Button
          className={`virtuali-btn ${
            location.pathname === "/" ? "active" : ""
          }`}
          onClick={() => {
            navigate("/");
          }}
        >
          {theme.isTablet && (
            <>
              <FontAwesomeIcon icon={faHome} />
              &nbsp;
            </>
          )}

          <FormattedMessage id="tabs.home" />
        </Button>
        <Button
          className={`virtuali-btn ${
            location.pathname.split("/")[1] === "sport" ? "active" : ""
          }`}
          onClick={() => {
            navigate("/sport");
          }}
        >
          {" "}
          <FormattedMessage id="tabs.sport" />
        </Button>

        <Button
          className={`virtuali-btn ${
            location.pathname.split("/")[1] === "sportlive" ? "active" : ""
          }`}
          onClick={() => {
            navigate("/sportlive");
          }}
        >
          {" "}
          <FormattedMessage id="tabs.sportlive" />
        </Button>

        <Button
          className={`virtuali-btn ${
            location.pathname.split("/")[1].includes("virtual") ? "active" : ""
          }`}
          onClick={() => {
            navigate("/virtual");
          }}
        >
          <FormattedMessage id="tabs.virtual" />
        </Button>
        <Button
          className={`virtuali-btn ${
            location.pathname.split("/")[1] === "casino" ? "active" : ""
          }`}
          onClick={() => {
            navigate("/casino");
          }}
        >
          {" "}
          <FormattedMessage id="tabs.casino" />
        </Button>
        <Button
          className={`virtuali-btn ${
            location.pathname.split("/")[1] === "live-casino" ? "active" : ""
          }`}
          onClick={() => {
            navigate("/live-casino");
          }}
        >
          {" "}
          <FormattedMessage id="tabs.casinolive" />
        </Button>
        <Button
          className={`virtuali-btn ${
            location.pathname.split("/")[1] === "poker" ? "active" : ""
          }`}
          onClick={() => {
            navigate("/poker");
          }}
        >
          {" "}
          <FormattedMessage id="tabs.poker" />
        </Button>
        <Button
          className={`virtuali-btn ${
            location.pathname.split("/")[1] === "lottery" ? "active" : ""
          }`}
          onClick={() => {
            navigate("/lottery");
          }}
        >
          {" "}
          <FormattedMessage id="tabs.lottery" />
        </Button>
        {/* <Button
          className={`virtuali-btn ${
            location.pathname.split("/")[1] === "skillgames" ? "active" : ""
          }`}
          onClick={() => {
            navigate("/skillgames");
          }}
        >
          {" "}
          <FormattedMessage id="tabs.skillgames" />
        </Button> */}

        <Button
          className={`virtuali-btn ${
            location.pathname === "/horseracing" ? "active" : ""
          }`}
          onClick={() => {
            navigate("/horseracing");
          }}
        >
          {" "}
          <FormattedMessage id="tabs.ippica" />
        </Button>
        {/*  <Button className={`virtuali-btn}`}>
          {" "}
          <FormattedMessage id="tabs.promotions" />
        </Button> */}

        <CloseButton
          onClose={() => {
            onClose();
          }}
        />
      </div>

  );
};

export default TabsBar;
